import React from "react";
import { observer } from "mobx-react";

import { ColumnTypeSelectorsPrematch } from "./ColumnTypeSelectorsPrematch";
import { ColumnTypeSelectorsLive } from "./ColumnTypeSelectorsLive";

export const ColumnTypeSelectors = observer(
	function ColumnTypeSelectors(props: {
		isLive?: boolean;
		isHome?: boolean;
	}) {
		if (props.isLive) {
			return <ColumnTypeSelectorsLive isHome={props.isHome} />;
		}

		return <ColumnTypeSelectorsPrematch />;
	}
);
